import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LuBedDouble, LuCalendarDays, LuLogOut } from 'react-icons/lu';
import { useGuestStore } from 'src/App';
import BottomNav from 'src/components/bottom-nav.component';

const initials = (name) =>
  (name || '').trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?';

const ProfilePage = () => {

  document.title = 'Profile | SNB';

  const navigate = useNavigate();
  const { name, room } = useGuestStore();

  const rows = [
    { Icon: LuBedDouble, label: 'Room No.', value: room },
    { Icon: LuCalendarDays, label: 'Event', value: 'SNB Nexus 2026' },
  ];

  const handleLogout = () => {
    useGuestStore.setState({ id: '', name: '', phone: '', room: '' });
    navigate('/guest-login');
  };

  return (
    <div className='home-wrapper app-wrapper agenda-page has-bottom-nav'>
      <div className='page-content'>
        <div className='agenda-topbar'>
          <ArrowBackIcon role='button' onClick={() => navigate('/home')} />
          <h1 className='agenda-day-title'>Profile</h1>
          <span style={{ width: 24 }} />
        </div>

        <div className='profile-hero'>
          <div className='profile-avatar'>{initials(name)}</div>
          <p className='home-name profile-name'>{name}</p>
          <p className='agenda-muted'>Guest · SNB Nexus 2026</p>
        </div>

        <ul className='profile-card'>
          {rows.map(({ Icon, label, value }) => (
            <li key={label}>
              <Icon className='profile-row-icon' />
              <div>
                <div className='agenda-muted'>{label}</div>
                {value || 'Not assigned'}
              </div>
            </li>
          ))}
        </ul>

        <button className='profile-logout' onClick={handleLogout}>
          <LuLogOut />
          Log out
        </button>
      </div>
      <BottomNav />
    </div>
  );
};

export default ProfilePage;
